import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoPrimeUpsellDialog',
  props: {
    value: { type: Boolean },
    name: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
}), expose: any, slots: any, attrs: any }) {





const { vm, yagiprimePaymentService } = useHostServices()

function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.rirekisho-prime-upsell-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onJoin() {
  emit('input', false)
  yagiprimePaymentService.useFeature(vm, 'prime-recommend', {
    onSuccess: () => {},
    onCancel: () => {}
  })
}

return { __sfc: true,emit, vm, yagiprimePaymentService, onOpened, onJoin }
}

})